<template>
    <div class="main-header">
      <div class="logo">
      <a href="/">
        <img
          src="@/assets/logo.png/"
          height="37"
          width="152" />
      </a>
        <span class="header-span">创作者中心</span>
      </div>
      <div class="user-info">
        <el-dropdown trigger="click">
          <img
            class="avatar"
            src="@/assets/user/defaultavatar.png" />
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item icon="Setting"><a href="/user/settings/profile">我的设置</a></el-dropdown-item>
              <el-dropdown-item
                icon="TurnOff"
                @click="logout"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
</template>
<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import { useUserInfoStore } from "@/stores/userInfo";
import { useOAuthStore } from "@/stores/oauth";

const router = useRouter();
const userStore = useUserInfoStore();
const oauthStore = useOAuthStore();
onMounted(async () => {
console.log('create in');

});

// 退出登录
const logout = () => {
  ElMessageBox.confirm(
    "确定登出吗？程序员正在改变世界，我们需要你和我们在一起！",
    "温馨提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(async () => {
      //清除 userinfo token
      oauthStore.clearToken();
      userStore.clearUser();
      localStorage.clear();
      router.push("/").then(() => {
        location.reload();
      });
      ElMessage.success("退出登录成功！");
    })
    .catch(() => {
      //错误捕获
    });
};
</script>

<style scoped>

.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  margin: 0 auto;
  max-width: 1440px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  margin-left: 40px;
}
.header-span {
  color: #cc5656;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 16px;
  margin-bottom: 16px;
  margin-top: 20px;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}
.user-info img.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
}
</style>
